import { gql } from '@apollo/client';

export const NOTIFICATION_QUERY = gql`
    query( $notificationID: UUID! ) {
        notification( notificationID: $notificationID ) {
            node {
                id
                isSticky
                isFeatured
                isPublished
                publishAt 
                unpublishAt 
                unfeatureAt
                weight
                brandIds
                localeIds
                segmentIds
                productIds
                learningProfileIds
                employeeLocaleIds
                companyRelationshipIds
                locales {
                    code
                    name
                    description
                }
            }
        }
    }
`;
